var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"ma-0 pa-0"},[_c('v-col',{attrs:{"md":"2","sm":"12","cols":"12"}},[_c('Sidebar')],1),_c('v-col',{attrs:{"md":"10","sm":"12"}},[_c('PersonCard',{attrs:{"expand":true,"UserId":_vm.UserId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }